<div id="provider-data-dialog" class="flex-column padding-20">
  <h2>Customer Contracts</h2>

  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (!loading && errorMessage != null) {
    <p class="mat-error">{{errorMessage}}</p>
  }

  @if (!loading && errorMessage == null) {
    <div class="scrollable-table">
      <table mat-table [dataSource]="contracts">
        <ng-container matColumnDef="updateDate">
          <th mat-header-cell *matHeaderCellDef> Update Date</th>
          <td mat-cell *matCellDef="let element"> {{element.updateDateUTC | date:'medium'}} </td>
        </ng-container>
        <ng-container matColumnDef="signed">
          <th mat-header-cell *matHeaderCellDef> Status</th>
          <td mat-cell *matCellDef="let element"> {{element.approvalStatus ? 'Signed' : 'Unsigned'}} </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            <button mat-icon-button
              (click)="load()"
              class="span-form margin-tb-10 float-right">
              <mat-icon>refresh</mat-icon>
            </button>
          </th>
          <td mat-cell *matCellDef="let element">
            <button mat-stroked-button
              color="primary"
              (click)="readContract(element.contractId)"
              class="span-form margin-tb-10 float-right">
              Read
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  }
  <div id="btn-div">
    <button style="margin-top: 10px" mat-stroked-button color="primary" [mat-dialog-close]="true">
      Close
    </button>
  </div>
</div>
